const bg = {
  interface: {
    writeMessage: 'Започнете да пишете...',
    attachFile: 'Прикачите файл',
    send: 'Изпратете',
    stopRecording: 'Спрете записа',
    record: 'Започнете записа',
    newMessages: 'Нови съобщения',
    removeFile: 'Изтрийте прикачения файл',
    maxFileSize: 'Максималният размер на файла е надвишен (20MB).',
    chatOffline: 'Не може да се свърже',
    aiGeneratedLabel: 'Генерирано от AI',
    aiGeneratedTooltip: 'Това съдържание е генерирано от AI'
  },
  error: {
    messageSend: 'Грешка при изпращане на съобщение. Моля, опитайте отново.',
    fileSend: 'Грешка при изпращане на файл. Моля, опитайте отново.',
    fileUpload: 'Грешка при качване на файл. Моля, опитайте отново.',
    isNotSupported: '{0} не се поддържа.'
  },
  welcome: '',
  buttonTitle: 'Искате помощ?'
}

const cs = {
  interface: {
    writeMessage: 'Začněte psát...',
    attachFile: 'Přiložit soubor',
    send: 'Odeslat',
    stopRecording: 'Zastavit nahrávání',
    record: 'Začít nahrávání',
    newMessages: 'Nové zprávy',
    removeFile: 'Odstranit přílohu',
    maxFileSize: 'Překročena max. velikost souboru (20MB).',
    chatOffline: 'Nelze se připojit',
    aiGeneratedLabel: 'Generováno AI',
    aiGeneratedTooltip: 'Tato zpráva byla generována AI'
  },
  error: {
    messageSend: 'Chyba při odesílání zprávy. Prosím, zkuste to znovu.',
    fileSend: 'Chyba při odesílání souboru. Prosím, zkuste to znovu.',
    fileUpload: 'Chyba při nahrávání souboru. Prosím, zkuste to znovu.',
    isNotSupported: '{0} není podporován.'
  },
  welcome: '',
  buttonTitle: 'Potřebujete poradit?'
}

const de = {
  interface: {
    writeMessage: 'Beginne mit dem Schreiben...',
    attachFile: 'Datei anhängen',
    send: 'Senden',
    stopRecording: 'Aufzeichnung stoppen',
    record: 'Aufnahme starten',
    newMessages: 'Neue Nachrichten',
    removeFile: 'Anhang entfernen',
    maxFileSize: 'Maximale Dateigröße (20 MB) überschritten.',
    chatOffline: 'Verbindung nicht möglich',
    aiGeneratedLabel: 'Von AI generiert',
    aiGeneratedTooltip: 'Dieser Inhalt wurde von AI generiert'
  },
  error: {
    messageSend: 'Fehler beim Senden der Nachricht. Bitte versuche es erneut.',
    fileSend: 'Fehler beim Senden der Datei. Bitte versuche es erneut.',
    fileUpload: 'Fehler beim Hochladen der Datei. Bitte versuche es erneut.',
    isNotSupported: '{0} wird nicht unterstützt.'
  },
  welcome: '',
  buttonTitle: 'Brauchst du Hilfe?'
}

const en = {
  interface: {
    writeMessage: 'Write a message...',
    attachFile: 'Attach a file',
    send: 'Send',
    stopRecording: 'Stop recording',
    record: 'Start recording',
    newMessages: 'New messages',
    removeFile: 'Remove the file',
    maxFileSize: 'Maximum file size (20MB) exceeded.',
    chatOffline: 'Chat is offline',
    aiGeneratedLabel: 'AI generated',
    aiGeneratedTooltip: 'This content was generated by AI'
  },
  error: {
    messageSend: 'Message could not be sent. Please try again.',
    fileSend: 'File could not be sent. Please try again.',
    fileUpload: 'File could not be uploaded. Please try again.',
    isNotSupported: '{0} is not supported.',
    dialCodeNoOptions: 'No options for {term}.'
  },
  welcome: '',
  buttonTitle: 'Need help?'
}

const es = {
  interface: {
    writeMessage: 'Enviar un mensaje',
    attachFile: 'Adjuntar archivo',
    send: 'Enviar',
    stopRecording: 'Detener grabación',
    record: 'Iniciar grabación',
    newMessages: 'Nuevos mensajes',
    removeFile: 'Eliminar adjunto',
    maxFileSize: 'Se excedió el tamaño máximo del archivo (20MB).',
    chatOffline: 'No se puede conectar',
    aiGeneratedLabel: 'Generado por AI',
    aiGeneratedTooltip: 'Este contenido fue generado por AI'
  },
  error: {
    messageSend: 'Error al enviar el mensaje. Por favor, inténtelo de nuevo.',
    fileSend: 'Error al enviar el archivo. Por favor, inténtelo de nuevo.',
    fileUpload: 'Error al subir el archivo. Por favor, inténtelo de nuevo.',
    isNotSupported: '{0} no es compatible.'
  },
  welcome: '',
  buttonTitle: '¿Necesitas ayuda?'
}

const et = {
  interface: {
    writeMessage: 'Kirjutage sõnum...',
    attachFile: 'Lisa manus.',
    send: 'Saada',
    stopRecording: 'Lõpetage salvestamine',
    record: 'Alustage salvestamist',
    newMessages: 'Uued teated.',
    removeFile: 'Eemalda fail.',
    maxFileSize: 'Maksimaalne failimaht (20 MB) on ületatud.',
    chatOffline: 'Jututuba ei ole aktiivne',
    aiGeneratedLabel: 'AI genereeritud',
    aiGeneratedTooltip: 'See sisu on loodud tehisintellekti abil'
  },
  error: {
    messageSend: 'Sõnumit ei saadetud. Palun proovi uuesti.',
    fileSend: 'Faili ei saadetud. Palun proovi uuesti.',
    fileUpload: 'Faili ei lisatud. Palun proovi uuesti.',
    isNotSupported: '{0} ei toetata.'
  },
  welcome: '',
  buttonTitle: 'Kas vajate abi?'
}

const fi = {
  interface: {
    writeMessage: 'Kirjoita viesti...',
    attachFile: 'Liitä tiedosto.',
    send: 'Lähettää',
    stopRecording: 'Lopeta nauhottaminen',
    record: 'Aloita nauhottaminen',
    newMessages: 'Uusia viestejä.',
    removeFile: 'Poista tiedosto.',
    maxFileSize: 'Tiedoston enimmäiskoko ylitetty (20MB).',
    chatOffline: 'Chat-keskustelu ei ole aktiivinen.',
    aiGeneratedLabel: 'AI-generoitu',
    aiGeneratedTooltip: 'Tämä sisältö on luotu tekoälyn avulla.'
  },
  error: {
    messageSend: 'Viestiä ei lähetetty. Voisitko yrittää uudelleen, kiitos..',
    fileSend: 'Tiedostoa ei lähetetty. Voisitko yrittää uudelleen, kiitos..',
    fileUpload: 'Tiedostoa ei ole liitetty. Voisitko yrittää uudelleen, kiitos..',
    isNotSupported: '{0} ei tueta.'
  },
  welcome: '',
  buttonTitle: 'Tarvitsetko apua?'
}

const fr = {
  interface: {
    writeMessage: 'Envoyer un message',
    attachFile: 'Joindre un fichier',
    send: 'Envoyer',
    stopRecording: 'Arrêter l\'enregistrement',
    record: 'Démarrer l\'enregistrement',
    newMessages: 'Nouveaux messages',
    removeFile: 'Supprimer la pièce jointe',
    maxFileSize: 'La taille maximale du fichier (20MB) a été dépassée',
    chatOffline: 'Impossible de se connecter',
    aiGeneratedLabel: 'Généré par AI',
    aiGeneratedTooltip: 'Ce contenu a été généré par AI'
  },
  error: {
    messageSend: 'Erreur lors de l\'envoi du message. Veuillez réessayer.',
    fileSend: 'Erreur lors de l\'envoi du fichier. Veuillez réessayer',
    fileUpload: 'Erreur lors du téléchargement du fichier. Veuillez réessayer.',
    isNotSupported: '{0} n\'est pas pris en charge.'
  },
  welcome: '',
  buttonTitle: 'Besoin d\'aide ?'
}

const gr = {
  interface: {
    writeMessage: 'Ξεκινήστε να γράφετε...',
    attachFile: 'Επισύναψη αρχείου',
    send: 'Αποστολή',
    stopRecording: 'Διακοπή εγγραφής',
    record: 'Έναρξη εγγραφής',
    newMessages: 'Νέα μηνύματα',
    removeFile: 'Κατάργηση συνημμένου',
    maxFileSize: 'Υπέρβαση του μέγιστου μεγέθους αρχείου (20 MB).',
    chatOffline: 'Δεν είναι δυνατή η σύνδεση',
    aiGeneratedLabel: 'Δημιουργήθηκε από AI',
    aiGeneratedTooltip: 'Αυτό το περιεχόμενο δημιουργήθηκε από AI'
  },
  error: {
    messageSend: 'Σφάλμα αποστολής μηνύματος. ΠΑΡΑΚΑΛΩ προσπαθησε ξανα.',
    fileSend: 'Σφάλμα αποστολής αρχείου. ΠΑΡΑΚΑΛΩ προσπαθησε ξανα.',
    fileUpload: 'Σφάλμα κατά τη μεταφόρτωση του αρχείου. ΠΑΡΑΚΑΛΩ προσπαθησε ξανα.',
    isNotSupported: '{0} δεν υποστηρίζεται.'
  },
  welcome: '',
  buttonTitle: 'Xρειάζεστε βοήθεια;'
}

const hr = {
  interface: {
    writeMessage: 'Počni pisati...',
    attachFile: 'Priloži datoteku',
    send: 'Pošalji',
    stopRecording: 'Zaustavi snimanje',
    record: 'Započni snimanje',
    newMessages: 'Nove poruke',
    removeFile: 'Ukloni privitak',
    maxFileSize: 'Premašena maksimalna veličina datoteke (20 MB).',
    chatOffline: 'Nije moguće povezati se',
    aiGeneratedLabel: 'Generirano od AI',
    aiGeneratedTooltip: 'Ovo sadržaj je generirano od AI'
  },
  error: {
    messageSend: 'Pogreška pri slanju poruke. Molim te pokušaj ponovno.',
    fileSend: 'Pogreška pri slanju datoteke. Molim te pokušaj ponovno.',
    fileUpload: 'Pogreška pri učitavanju datoteke. Molim te pokušaj ponovno.',
    isNotSupported: '{0} nije podržan.'
  },
  welcome: '',
  buttonTitle: 'Trebate pomoć?'
}

const hu = {
  interface: {
    writeMessage: 'Kezdj el írni...',
    attachFile: 'Fájl csatolása',
    send: 'Küld',
    stopRecording: 'Állítsa le a felvételt',
    record: 'Felvétel megkezdése',
    newMessages: 'Új üzenetek',
    removeFile: 'Törölje a mellékletet',
    maxFileSize: 'A maximális fájlméret túllépve (20 MB) ',
    chatOffline: 'Nem tud csatlakozni',
    aiGeneratedLabel: 'AI által generált',
    aiGeneratedTooltip: 'Ez a tartalom AI által generált'
  },
  error: {
    messageSend: 'Hiba az üzenet küldésekor. Kérlek próbáld újra.',
    fileSend: 'Hiba a fájl küldésekor. Kérlek próbáld újra.',
    fileUpload: 'Hiba a fájl feltöltésekor. Kérlek próbáld újra.',
    isNotSupported: '{0} nem támogatott.'
  },
  welcome: '',
  buttonTitle: 'Segíthetek?'
}

const lt = {
  interface: {
    writeMessage: 'Rašyti žinutę...',
    attachFile: 'Prisegti failą.',
    send: 'Siųsti',
    stopRecording: 'Sustabdykite įrašymą',
    record: 'Pradėkite įrašymą',
    newMessages: 'Naujos žinutės.',
    removeFile: 'Pašalinti failą.',
    maxFileSize: 'Viršytas maksimalus failo dydis (20MB).',
    chatOffline: 'Pokalbių kambarys neaktyvus.',
    aiGeneratedLabel: 'Generuotas AI',
    aiGeneratedTooltip: 'Šis turinys buvo generuotas AI'
  },
  error: {
    messageSend: 'Žinutė nebuvo išsiųsta. Pabandykite dar kartą.',
    fileSend: 'Failas nebuvo išsiųstas. Pabandykite dar kartą.',
    fileUpload: 'Failas nebuvo prisegtas. Pabandykite dar kartą.',
    isNotSupported: '{0} nepalaikomas.'
  },
  welcome: '',
  buttonTitle: 'Reikia pagalbos?'
}

const lv = {
  interface: {
    writeMessage: 'Rakstīt  ziņu...',
    attachFile: 'Pievienot pielikumu.',
    send: 'Nosūtīt',
    stopRecording: 'Pabeigt ierakstu',
    record: 'Sākt ierakstu',
    newMessages: 'Jauna ziņa.',
    removeFile: 'Dzēst pielikumu.',
    maxFileSize: 'Pārsniegts pielikuma maksimālais lielums (20 MB).',
    chatOffline: 'Tērzēšanas telpa nav aktīva',
    aiGeneratedLabel: 'AI ģenerēts',
    aiGeneratedTooltip: 'Šis saturs ir ģenerēts ar AI'
  },
  error: {
    messageSend: 'Ziņa nav nosūtīta. Lūdzu, mēģiniet vēlreiz..',
    fileSend: 'Pielikums nav nosūtīts. Lūdzu, mēģiniet vēlreiz..',
    fileUpload: 'Pielikums nav pievienots. Lūdzu, mēģiniet vēlreiz..',
    isNotSupported: '{0} netiek atbalstīts.'
  },
  welcome: '',
  buttonTitle: 'Nepieciešama palīdzība?'
}

const nl = {
  interface: {
    writeMessage: 'Begin met schrijven...',
    attachFile: 'Bijlage',
    send: 'Versturen',
    stopRecording: 'Stop met opnemen',
    record: 'Begin met opnemen',
    newMessages: 'Nieuwe berichten',
    removeFile: 'Verwijder de bijlage',
    maxFileSize: 'Maximale bestandsgrootte overschreden (20MB).',
    chatOffline: 'Niet in staat te verbinden',
    aiGeneratedLabel: 'Door AI gegenereerd',
    aiGeneratedTooltip: 'Deze inhoud is gegenereerd door AI'
  },
  error: {
    messageSend: 'Fout bij verzenden van bericht. Probeer het opnieuw.',
    fileSend: 'Fout bij verzenden van bestand. Probeer het opnieuw.',
    fileUpload: 'Fout bij uploaden van bestand. Probeer het opnieuw.',
    isNotSupported: '{0} wordt niet ondersteund.'
  },
  welcome: '',
  buttonTitle: 'Hulp nodig?'
}

const pl = {
  interface: {
    writeMessage: 'Wyślij wiadomość',
    attachFile: 'Załącz plik',
    send: 'Wyślij',
    stopRecording: 'Zatrzymaj nagrywanie',
    record: 'Rozpocznij nagrywanie',
    newMessages: 'Nowe wiadomości',
    removeFile: 'Usuń załącznik',
    maxFileSize: 'Przekroczono maksymalny rozmiar pliku (20 MB).',
    chatOffline: 'Nie można się połączyć',
    aiGeneratedLabel: 'Generowane przez AI',
    aiGeneratedTooltip: 'To treść została wygenerowana przez AI'
  },
  error: {
    messageSend: 'Błąd podczas wysyłania wiadomości. Proszę spróbuj ponownie.',
    fileSend: 'Błąd wysyłania pliku. Proszę spróbuj ponownie.',
    fileUpload: 'Błąd podczas przesyłania pliku. Proszę spróbuj ponownie.',
    isNotSupported: '{0} nie jest obsługiwane.'
  },
  welcome: '',
  buttonTitle: 'Pomóc?'
}

const ro = {
  interface: {
    writeMessage: 'Începe să scrii...',
    attachFile: 'Atașați fișierul',
    send: 'Trimite',
    stopRecording: 'Opriți înregistrarea',
    record: 'Începe înregistrarea',
    newMessages: 'Mesaje noi',
    removeFile: 'Eliminați atașamentul',
    maxFileSize: 'S-a depășit dimensiunea maximă a fișierului (20 MB).',
    chatOffline: 'Nu se poate conecta',
    aiGeneratedLabel: 'Generat de AI',
    aiGeneratedTooltip: 'Acest conținut a fost generat de AI'
  },
  error: {
    messageSend: 'Eroare la trimiterea mesajului. Vă rugăm să încercați din nou.',
    fileSend: 'Eroare la trimiterea fișierului. Vă rugăm să încercați din nou.',
    fileUpload: 'Eroare la încărcarea fișierului. Vă rugăm să încercați din nou.',
    isNotSupported: '{0} nu este suportat.'
  },
  welcome: '',
  buttonTitle: 'Ai nevoie de ajutor?'
}

const rs = {
  interface: {
    writeMessage: 'Pošalji poruku',
    attachFile: 'Priložite datoteku',
    send: 'Pošalji',
    stopRecording: 'Zaustavi snimanje',
    record: 'Počeli sa snimanjem',
    newMessages: 'Nove poruke',
    removeFile: 'Uklonite prilog',
    maxFileSize: 'Prekoračena je maksimalna veličina datoteke (20MB).',
    chatOffline: 'Nije moguće povezati se',
    aiGeneratedLabel: 'Generisano od AI',
    aiGeneratedTooltip: 'Ovo sadržaj je generisano od AI'
  },
  error: {
    messageSend: 'Greška pri slanju poruke. Molim vas, pokušajte ponovo.',
    fileSend: 'Greška pri slanju datoteke. Molim vas, pokušajte ponovo.',
    fileUpload: 'Greška pri otpremanju datoteke. Molim vas, pokušajte ponovo.',
    isNotSupported: '{0} nije podrzan.'
  },
  welcome: '',
  buttonTitle: 'Mogu li savetovati?'
}

const ru = {
  interface: {
    writeMessage: 'Напишите сообщение...',
    attachFile: 'Прикрепить файл',
    send: 'Отправить',
    stopRecording: 'Остановить запись',
    record: 'Начать запись',
    newMessages: 'Новые сообщения',
    removeFile: 'Удалить файл',
    maxFileSize: 'Максимальный размер файла (20 МБ) установлен.',
    chatOffline: 'Чат недоступен',
    aiGeneratedLabel: 'Сгенерировано ИИ',
    aiGeneratedTooltip: 'Этот контент создан с помощью ИИ'
  },
  error: {
    messageSend: 'Ошибка отправки сообщения. Пожалуйста, попробуйте еще раз.',
    fileSend: 'Ошибка отправки файла. Пожалуйста, попробуйте еще раз.',
    fileUpload: 'Ошибка загрузки файла. Пожалуйста, попробуйте еще раз.',
    isNotSupported: '{0} не поддерживается.'
  },
  welcome: '',
  buttonTitle: 'Нужна помощь?'
}

const sk = {
  interface: {
    writeMessage: 'Napíšte svoju otázku...',
    attachFile: 'Priložiť súbor',
    send: 'Odoslať',
    stopRecording: 'Zastaviť nahrávanie',
    record: 'Začať nahrávanie',
    newMessages: 'Nové správy',
    removeFile: 'Odstrániť prílohu',
    maxFileSize: 'Prekročená max. veľkosť súboru (20MB).',
    chatOffline: 'Nedá sa pripojiť',
    aiGeneratedLabel: 'Generované AI',
    aiGeneratedTooltip: 'Tento obsah bol generovaný AI'
  },
  error: {
    messageSend: 'Chyba pri odosielaní správy. Prosím, skúste to znova.',
    fileSend: 'Chyba pri odosielaní súboru. Prosím, skúste to znova.',
    fileUpload: 'Chyba pri nahrávaní súboru. Prosím, skúste to znova.',
    isNotSupported: '{0} nie je podporovaná.'
  },
  welcome: '',
  buttonTitle: 'Neviete si rady?'
}

const sl = {
  interface: {
    writeMessage: 'Pošlji sporočilo',
    attachFile: 'Priloži datoteko',
    send: 'Pošlji',
    stopRecording: 'Ustavi snemanje',
    record: 'Začni snemati',
    newMessages: 'Nova sporočila',
    removeFile: 'Odstrani prilogo',
    maxFileSize: 'Presežena največja velikost datoteke (20 MB).',
    chatOffline: 'Ni mogoče vzpostaviti povezave',
    aiGeneratedLabel: 'Generirano od AI',
    aiGeneratedTooltip: 'To vsebina je generirana od AI'
  },
  error: {
    messageSend: 'Napaka pri pošiljanju sporočila. Poskusite znova.',
    fileSend: 'Napaka pri pošiljanju datoteke. Poskusite znova.',
    fileUpload: 'Napaka pri nalaganju datoteke. Poskusite znova.',
    isNotSupported: '{0} ni podprt.'
  },
  welcome: '',
  buttonTitle: 'Potrebujete pomoč?'
}

const uz = {
  interface: {
    writeMessage: 'Savolni yozing...',
    attachFile: 'Faylni biriktirish',
    send: 'Yuborish',
    stopRecording: 'Tizimni to‘xtatish',
    record: 'Nashr boshlash',
    newMessages: 'Yangi xabarlar',
    removeFile: 'Faylni olib tashlash',
    maxFileSize: 'Maksimum fayl hajmi (20MB) tashkil etildi.',
    chatOffline: 'Ulanmaydi',
    aiGeneratedLabel: 'AI tarjima qilingan',
    aiGeneratedTooltip: 'Bu ma’lumot AI tarjima qilingan'
  },
  error: {
    messageSend: 'Xabar yuborishda xatolik. Iltimos, qaytadan urinib ko‘ring.',
    fileSend: 'Faylni yuborishda xatolik. Iltimos, qaytadan urinib ko‘ring.',
    fileUpload: 'Faylni yuklashda xatolik. Iltimos, qaytadan urinib ko‘ring.',
    isNotSupported: '{0} qo\'llab-quvvatlanmaydi.'
  },
  welcome: '',
  buttonTitle: 'Yordam kerakmi?'
}

export default {
  bg: bg,
  cs: cs,
  de: de,
  en: en,
  es: es,
  et: et,
  fi: fi,
  fr: fr,
  gr: gr,
  hr: hr,
  hu: hu,
  lt: lt,
  lv: lv,
  nl: nl,
  pl: pl,
  ro: ro,
  rs: rs,
  ru: ru,
  sk: sk,
  sl: sl,
  uz: uz,

  'bg-footshop': bg,

  'cs-datart': Object.assign({}, cs, {
    welcome: '<span class="font-light">virtuální asistent <strong>RICH</strong>ART</span>',
    buttonTitle: 'Nevíte si rady?'
  }),

  'cs-frantiskovylazne': Object.assign({}, cs, {
    welcome: 'Asistent František',
    buttonTitle: 'Potřebujete poradit?'
  }),

  'cs-sporttown': Object.assign({}, cs, {
    welcome: 'Virtuální asistentka SÁRA',
    buttonTitle: 'Potřebujete poradit?'
  }),

  'cs-footshop': Object.assign({}, cs, {
    welcome: '',
    buttonTitle: 'Potřebuješ pomoct?'
  }),

  'cs-oveckarna': Object.assign({}, cs, {
    welcome: 'Ovečkárna',
    buttonTitle: 'Potřebuješ pomoct?'
  }),

  'cs-supportbox': Object.assign({}, cs, {
    welcome: 'Demo chatbot Shopy',
    buttonTitle: 'Zkuste chatbota'
  }),

  'cs-vasky': Object.assign({}, cs, {
    welcome: '',
    buttonTitle: 'Vánoční rádce'
  }),

  'cs-mtbiker': Object.assign({}, cs, {
    welcome: '<svg width="220" height="60"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/mtbiker.svg" width="220" height="60"/></svg>',
    buttonTitle: 'Nevíte si rady?'
  }),

  'cs-factcool': Object.assign({}, cs, {
    welcome: '',
    buttonTitle: 'Nevíte si rady?'
  }),

  'cs-bezvasport': Object.assign({}, cs, {
    welcome: '<svg width="220" height="60"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/bezvasport-cs.svg" width="220" height="60"/></svg>',
    buttonTitle: 'Nevíte si rady?'
  }),

  'cs-europosters': Object.assign({}, cs, {
    welcome: '<svg width="220" height="40"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/europosters-cs.svg" width="170" height="40"/></svg>',
    buttonTitle: 'Potřebujete poradit?'
  }),

  'cs-istyle': Object.assign({}, cs, {
    welcome: '<svg width="170" height="50"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/istyle.svg" width="170" height="50"/></svg>',
    buttonTitle: ''
  }),

  'cs-alexandria': Object.assign({}, cs, {
    welcome: '<svg width="200" height="50"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/alexandria-cs.svg" width="200" height="50"/></svg>',
    buttonTitle: 'Nevíte si rady?'
  }),

  'cs-pilulka': Object.assign({}, cs, {
    welcome: '<svg width="120" height="30"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/pilulka.svg" width="120" height="30"/></svg>',
    buttonTitle: 'Nevíte si rady?'
  }),

  'cs-donio': Object.assign({}, cs, {
    welcome: '<svg width="120" height="50" viewBox="-60 -25 550 190"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/donio.svg" width="500" height="220"/></svg>',
    buttonTitle: 'Nevíte si rady?'
  }),

  'cs-regaly': Object.assign({}, cs, {
    welcome: '',
    buttonTitle: 'Nevíte si rady?'
  }),

  'cs-exasoft': Object.assign({}, cs, {
    welcome: 'Asistent Felix',
    buttonTitle: 'Nevíte si rady?'
  }),

  'cs-bagind': Object.assign({}, cs, {
    welcome: '<svg width="180" height="57"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/bagind.svg" width="300" height="57"/></svg>',
    buttonTitle: 'Bagind rádce'
  }),

  'cs-protech': Object.assign({}, cs, {
    welcome: '<span style="padding-left:15px">PRO-TECH SHOP</span>',
    buttonTitle: ''
  }),

  'cs-sportega': Object.assign({}, cs, {
    welcome: '',
    buttonTitle: 'Potřebuješ poradit?'
  }),

  'cs-textilomanie': Object.assign({}, cs, {
    welcome: '',
    buttonTitle: 'Nevíte si rady?'
  }),

  'cs-alpinepro': Object.assign({}, cs, {
    welcome: '<svg xmlns="http://www.w3.org/2000/svg" class="svg" version="1.1" x="0px" y="0px" viewBox="60 0 640 640" xml:space="preserve"><style type="text/css"> .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}</style><path class="st0" d="M260,311.6h11.6v30.4H260V311.6z M326.3,336.9H326l-25.7-25.4h-19.1v30.4h11.6l-0.3-12.8l-0.6-12.6h0.5  l25.4,25.4H337v-30.4h-11.6L326.3,336.9z M355.9,328.9H384v-4.7h-28.1v-7.6h29.6v-5h-41.1v30.4h41.3v-5h-29.8V328.9z M505.8,327.2  c-1.8,1.1-4.4,1.7-8,2v0.1c3.4,0.2,6.2,0.8,8,1.8c1.2,1,2.2,3,2.2,5.1v5.6h-11.6v-4.6c0-1.5,0-3.3-1.8-4.4c-1.8-1-4.2-1.1-7.4-1.1  h-16.1v10.1h-11.5v-30.4H489c6.9,0,12.8,0.7,15.7,2.3c2.6,1.5,3.6,4,3.6,6.7C508.4,322.3,508.4,325.6,505.8,327.2 M495.1,325.7  c1.5-1,1.7-2.8,1.7-4.2c0-1.5-0.2-3-1.4-3.9c-1.6-1-4.7-1.1-8.2-1.1h-16.2v10.4h16.6C491.5,326.9,493.4,326.6,495.1,325.7   M432.1,311.5c6.7,0,15.9,0.2,19.5,3.6c1.8,2.1,2.1,4.4,2.1,6.6c0,2.6-0.5,5.9-3.7,7.9c-2.6,1.7-9.4,2.4-15.1,2.4h-17.5v9.8h-11.5  v-30.4H432.1 M440.1,326.3c2.4-1,2.2-2.2,2.4-4.3c0-2-0.3-3.2-1.3-4.1c-1.3-1.1-3.8-1.5-8.9-1.5h-14.9v10.6H432  C435.4,327.1,438.7,327,440.1,326.3 M560.1,314.7c0,0,3.7,2,3.7,7.5v9.6c0,4.1-2,5.7-3.8,7c-4.5,3.2-15,3.1-22.8,3.1  c-7.2,0-14.6-0.2-18.8-2.6c-3.5-1.8-4.5-5.2-4.5-8.4v-8.2c0-2.7,0.3-5.9,3.4-8.2c4.2-2.9,14.3-3,21.4-3  C545.5,311.6,556.3,311.8,560.1,314.7 M552.4,322c0-1.3-0.3-3-2-4.1c-1.3-0.7-3.7-1.2-6.1-1.3c-2.6-0.1-2.9-0.1-5.6-0.1  c-6.6-0.1-11,0.3-12.4,1.9c-1.2,1.3-1.2,2.8-1.3,4c0,1.3,0,0.6,0,0.9v7.1c0,2.9,0.9,4.4,1.7,5.1c2,1.6,6.4,1.6,11.8,1.6  c6.6-0.1,9.9-0.4,11.9-1.6c1.2-0.9,2-2.7,2-4.5V322 M232.4,311.6c6.7,0,15.9,0.2,19.5,3.6c1.8,2.1,2.2,4.4,2.2,6.6  c0,2.6-0.5,5.9-3.7,7.9c-2.6,1.7-9.3,2.4-15.1,2.4h-17.5v9.8h-11.5v-30.4H232.4 M240.3,326.3c2.4-1,2.2-2.2,2.4-4.3  c0-2-0.3-3.2-1.3-4.1c-1.3-1.1-3.7-1.5-8.9-1.5h-14.8v10.6h14.5C235.7,327.1,238.9,327,240.3,326.3 M174.9,311.6h-11.6v30.4H203v-5  h-28.1V311.6z M158.4,297.4l0,58.5H80.9l2-5.6l2.8-4.8l2.3-2.6c0,0,0.9-3.3,1.6-5.1c0.7-1.7,2.7-1.2,4.3-1.7  c1.6-0.5,2.2-6.6,3.1-9.1c0.9-2.5,2.1-4.5,3.2-6.5c0.8-1.6,1.5-3.1,2.7-4.8c1.2-1.8,0.4-0.5,0-3.5c-0.4-3,2-3.6,2-3.6l4.3-4.2  l3.5-4.2l1.2-2.8L158.4,297.4z M154.4,341.9L134,311.6h-16.8l-6.2,9.3l-13.7,21.1h11.9l3.8-5.7h25.9l3.8,5.7H154.4z M125.8,316  l-10.3,15.8h20.7L125.8,316L125.8,316z"/></svg>',
    buttonTitle: 'Nevíte si rady?'
  }),

  'cs-multisport': Object.assign({}, cs, {
    welcome: '<svg width="176" height="37"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/multisport.svg" width="176" height="37"/></svg>',
    buttonTitle: 'Nevíte si rady?'
  }),

  'de-footshop': de,

  'en-multisport': Object.assign({}, en, {
    welcome: '<svg width="176" height="37"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/multisport.svg" width="176" height="37"/></svg>',
    buttonTitle: 'Need help?'
  }),

  'en-footshop': en,

  'en-europosters': Object.assign({}, en, {
    welcome: '<svg width="180" height="50"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/europosters.svg" width="180" height="50"/></svg>',
    buttonTitle: 'Need help?'
  }),

  'en-irisimo': Object.assign({}, en, {
    welcome: '<svg width="174" height="24" style="margin-left:10px; margin-top:2px"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/irisimo.svg" width="174" height="24"/></svg>',
    buttonTitle: 'Need help?'
  }),

  'es-footshop': es,

  'et-pigu': Object.assign({}, et, {
    welcome: '<strong>Virtuaalne assistent</strong>',
    buttonTitle: 'Kas vajate abi?'
  }),

  'fi-pigu': Object.assign({}, fi, {
    welcome: '<strong>Virtuaaliassistentti</strong>',
    buttonTitle: 'Tarvitsetko apua?'
  }),

  'fr-europosters': Object.assign({}, fr, {
    welcome: '<svg width="180" height="50"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/europosters.svg" width="180" height="50"/></svg>',
    buttonTitle: 'Besoin d\'aide ?'
  }),

  'fr-footshop': fr,

  'gr-footshop': gr,

  'hr-footshop': Object.assign({}, hr, {
    welcome: '',
    buttonTitle: 'Trebate pomoć?'
  }),

  'hr-froddo': Object.assign({}, hr, {
    welcome: '<svg width="220" height="50"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/froddo.svg" width="220" height="50"/></svg>',
    buttonTitle: 'Trebate pomoć?'
  }),

  'hu-textilomanie': Object.assign({}, hu, {
    welcome: '<svg width="250" height="50"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/textilomanie-hu.svg" width="250" height="50"/></svg>',
    buttonTitle: 'Segíthetek?'
  }),

  'hu-footshop': hu,

  'lt-pigu': Object.assign({}, lt, {
    welcome: '<strong>Virtualus asistentas</strong>',
    buttonTitle: 'Reikia pagalbos?'
  }),

  'lv-pigu': Object.assign({}, lv, {
    welcome: '<strong>Virtuālais palīgs</strong>',
    buttonTitle: 'Nepieciešama palīdzība?'
  }),

  'nl-footshop': nl,

  'nl-hostingvergelijker': Object.assign({}, nl, {
    welcome: '<svg width="220" height="50" style="margin-top: 5px;"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/hostingvergelijker.png" width="220" height="50"/></svg>'
  }),

  'pl-textilomanie': Object.assign({}, pl, {
    welcome: '<svg width="220" height="50"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/textilomanie-pl.svg" width="220" height="50"/></svg>',
    buttonTitle: 'Pomóc?'
  }),

  'pl-footshop': pl,

  'ro-sejurexotic': Object.assign({}, ro, {
    welcome: '<svg width="36" height="36" style="background: #fff; margin-top: 10px; color:#000; float: left; border-radius: 50%;"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/sejurexotic.svg" /></svg><span style="color:#000; float:left; margin: 15px 5px;">sejur<strong style="color:#fff">exotic</strong></span>',
    buttonTitle: 'Ai nevoie de ajutor?'
  }),

  'ro-textilomanie': Object.assign({}, ro, {
    welcome: '<svg width="220" height="50"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/textilomanie-ro.svg" width="220" height="50"/></svg>',
    buttonTitle: 'Ai nevoie de ajutor?'
  }),

  'ro-footshop': ro,

  'rs-hiper': Object.assign({}, rs, {
    welcome: '<div style="align-items: center; display: flex; font-size: 30px;"><svg width="50" height="55"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/hiper.svg" width="50" height="50"/></svg>Zdravo!</div>',
    buttonTitle: 'Mogu li savetovati?'
  }),

  'rs-europcar': Object.assign({}, rs, {
    welcome: '',
    buttonTitle: 'Mogu li savetovati?'
  }),

  'rs-beosport': Object.assign({}, rs, {
    welcome: '',
    buttonTitle: 'Mogu li savetovati?'
  }),

  'rs-wobyhaus': Object.assign({}, rs, {
    welcome: '<svg width="140" height="40"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/wobyhaus.svg" /></svg>',
    buttonTitle: 'Možemo pomoći?'
  }),

  'ru-zood': ru,

  'sl-footshop': Object.assign({}, sl, {
    welcome: '',
    buttonTitle: 'Potrebujete pomoč?'
  }),

  'sk-datart': Object.assign({}, sk, {
    welcome: '<span class="font-light">virtuálny asistent <strong>RICH</strong>ART</span>',
    buttonTitle: 'Neviete si rady?'
  }),

  'sk-protech': Object.assign({}, sk, {
    welcome: '<span style="padding-left:15px">PRO-TECH SHOP</span>',
    buttonTitle: ''
  }),

  'sk-footshop': Object.assign({}, sk, {
    welcome: '<span class="font-light">virtuálny asistent <strong>RICH</strong>ART</span>',
    buttonTitle: 'Potrebuješ pomôcť?'
  }),

  'sk-grizly': Object.assign({}, sk, {
    welcome: '',
    buttonTitle: 'S čím vám môžem pomôcť?'
  }),

  'sk-alpinepro': Object.assign({}, sk, {
    welcome: '<svg xmlns="http://www.w3.org/2000/svg" class="svg" version="1.1" x="0px" y="0px" viewBox="60 0 640 640" xml:space="preserve"><style type="text/css"> .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}</style><path class="st0" d="M260,311.6h11.6v30.4H260V311.6z M326.3,336.9H326l-25.7-25.4h-19.1v30.4h11.6l-0.3-12.8l-0.6-12.6h0.5  l25.4,25.4H337v-30.4h-11.6L326.3,336.9z M355.9,328.9H384v-4.7h-28.1v-7.6h29.6v-5h-41.1v30.4h41.3v-5h-29.8V328.9z M505.8,327.2  c-1.8,1.1-4.4,1.7-8,2v0.1c3.4,0.2,6.2,0.8,8,1.8c1.2,1,2.2,3,2.2,5.1v5.6h-11.6v-4.6c0-1.5,0-3.3-1.8-4.4c-1.8-1-4.2-1.1-7.4-1.1  h-16.1v10.1h-11.5v-30.4H489c6.9,0,12.8,0.7,15.7,2.3c2.6,1.5,3.6,4,3.6,6.7C508.4,322.3,508.4,325.6,505.8,327.2 M495.1,325.7  c1.5-1,1.7-2.8,1.7-4.2c0-1.5-0.2-3-1.4-3.9c-1.6-1-4.7-1.1-8.2-1.1h-16.2v10.4h16.6C491.5,326.9,493.4,326.6,495.1,325.7   M432.1,311.5c6.7,0,15.9,0.2,19.5,3.6c1.8,2.1,2.1,4.4,2.1,6.6c0,2.6-0.5,5.9-3.7,7.9c-2.6,1.7-9.4,2.4-15.1,2.4h-17.5v9.8h-11.5  v-30.4H432.1 M440.1,326.3c2.4-1,2.2-2.2,2.4-4.3c0-2-0.3-3.2-1.3-4.1c-1.3-1.1-3.8-1.5-8.9-1.5h-14.9v10.6H432  C435.4,327.1,438.7,327,440.1,326.3 M560.1,314.7c0,0,3.7,2,3.7,7.5v9.6c0,4.1-2,5.7-3.8,7c-4.5,3.2-15,3.1-22.8,3.1  c-7.2,0-14.6-0.2-18.8-2.6c-3.5-1.8-4.5-5.2-4.5-8.4v-8.2c0-2.7,0.3-5.9,3.4-8.2c4.2-2.9,14.3-3,21.4-3  C545.5,311.6,556.3,311.8,560.1,314.7 M552.4,322c0-1.3-0.3-3-2-4.1c-1.3-0.7-3.7-1.2-6.1-1.3c-2.6-0.1-2.9-0.1-5.6-0.1  c-6.6-0.1-11,0.3-12.4,1.9c-1.2,1.3-1.2,2.8-1.3,4c0,1.3,0,0.6,0,0.9v7.1c0,2.9,0.9,4.4,1.7,5.1c2,1.6,6.4,1.6,11.8,1.6  c6.6-0.1,9.9-0.4,11.9-1.6c1.2-0.9,2-2.7,2-4.5V322 M232.4,311.6c6.7,0,15.9,0.2,19.5,3.6c1.8,2.1,2.2,4.4,2.2,6.6  c0,2.6-0.5,5.9-3.7,7.9c-2.6,1.7-9.3,2.4-15.1,2.4h-17.5v9.8h-11.5v-30.4H232.4 M240.3,326.3c2.4-1,2.2-2.2,2.4-4.3  c0-2-0.3-3.2-1.3-4.1c-1.3-1.1-3.7-1.5-8.9-1.5h-14.8v10.6h14.5C235.7,327.1,238.9,327,240.3,326.3 M174.9,311.6h-11.6v30.4H203v-5  h-28.1V311.6z M158.4,297.4l0,58.5H80.9l2-5.6l2.8-4.8l2.3-2.6c0,0,0.9-3.3,1.6-5.1c0.7-1.7,2.7-1.2,4.3-1.7  c1.6-0.5,2.2-6.6,3.1-9.1c0.9-2.5,2.1-4.5,3.2-6.5c0.8-1.6,1.5-3.1,2.7-4.8c1.2-1.8,0.4-0.5,0-3.5c-0.4-3,2-3.6,2-3.6l4.3-4.2  l3.5-4.2l1.2-2.8L158.4,297.4z M154.4,341.9L134,311.6h-16.8l-6.2,9.3l-13.7,21.1h11.9l3.8-5.7h25.9l3.8,5.7H154.4z M125.8,316  l-10.3,15.8h20.7L125.8,316L125.8,316z"/></svg>',
    buttonTitle: 'Môžem pomôcť?'
  }),

  'sk-textilomanie': Object.assign({}, sk, {
    welcome: '<svg width="220" height="50"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/textilomanie-sk.svg" width="220" height="50"/></svg>',
    buttonTitle: 'Môžem pomôcť?'
  }),

  'sk-kaskady': Object.assign({}, sk, {
    welcome: '<svg width="60" height="40"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/kaskady-sk.svg" /></svg><svg width="180" height="40"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/kaskady-sk2.svg" /></svg>',
    buttonTitle: 'Neviete si rady?'
  }),

  'sk-pilulka': Object.assign({}, sk, {
    welcome: '<svg width="120" height="30"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/pilulka.svg" width="120" height="30"/></svg>',
    buttonTitle: 'Neviete si rady?'
  }),

  'sk-europosters': Object.assign({}, sk, {
    welcome: '<svg width="140" height="50"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/europosters-sk.svg" width="140" height="50"/></svg>',
    buttonTitle: 'Potrebuješ pomôcť?'
  }),

  'sk-factcool': Object.assign({}, sk, {
    welcome: '',
    buttonTitle: 'Neviete si rady?'
  }),

  'sk-bezvasport': Object.assign({}, sk, {
    welcome: '<svg width="220" height="60"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/bezvasport-cs.svg" width="220" height="60"/></svg>',
    buttonTitle: 'Neviete si rady?'
  }),

  'sk-mtbiker': Object.assign({}, sk, {
    welcome: '<svg width="190" height="45"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/mtbiker.svg" width="190" height="45"/></svg>',
    buttonTitle: 'Neviete si rady?'
  }),

  'sk-donio': Object.assign({}, sk, {
    welcome: '<svg width="120" height="50" viewBox="-60 -25 550 190"><image xlink:href="https://amio-assets.s3.eu-central-1.amazonaws.com/donio.svg" width="500" height="220"/></svg>',
    buttonTitle: 'Neviete si rady?'
  }),

  'uz-zood': uz,

  'uz-fargo': Object.assign({}, uz, {
    welcome: '<img style="margin-top: 10px" src="https://amio-assets.s3.eu-central-1.amazonaws.com/image+(36).png" width="188" height="27"/>'
  }),

  'ru-fargo': Object.assign({}, ru, {
    welcome: '<img style="margin-top: 10px" src="https://amio-assets.s3.eu-central-1.amazonaws.com/image+(36).png" width="188" height="27"/>'
  }),

  'en-fargo': Object.assign({}, en, {
    welcome: '<img style="margin-top: 10px" src="https://amio-assets.s3.eu-central-1.amazonaws.com/image+(36).png" width="188" height="27"/>'
  }),

  'sk-knifestock': Object.assign({}, sk, {
    welcome: '<img style="margin-top: 10px" src="https://amio-assets.s3.eu-central-1.amazonaws.com/knifestock-2.svg" width="150" height="30"/>'
  }),

  'de-spabooking': Object.assign({}, de, {
    welcome: '<img src="https://amio-assets.s3.eu-central-1.amazonaws.com/spabooking.svg" width="150" height="30"/>'
  }),

  'cs-spabooking': Object.assign({}, cs, {
    welcome: '<img src="https://amio-assets.s3.eu-central-1.amazonaws.com/spabooking.svg" width="150" height="30"/>'
  }),

  'cs-fajntricko': Object.assign({}, cs, {
    welcome: '<img src="https://amio-assets.s3.eu-central-1.amazonaws.com/fajntricko.svg" style="margin-top: 7px" width="151" height="45"/>'
  }),

  'sk-fajntricko': Object.assign({}, sk, {
    welcome: '<img src="https://amio-assets.s3.eu-central-1.amazonaws.com/fajntricko.svg" style="margin-top: 7px" width="151" height="45"/>'
  }),

  'en-fajntricko': Object.assign({}, en, {
    welcome: '<img src="https://amio-assets.s3.eu-central-1.amazonaws.com/fajntricko.svg" style="margin-top: 7px" width="151" height="45"/>'
  })
}
